import React from "react";

export default function ProfitLineChart({ data }) {
  const values = data.map(function mapPoint(point) {
    return point.share;
  });
  const width = 680;
  const height = 180;
  const padding = { left: 48, right: 12, top: 12, bottom: 28 };
  const maxValue = Math.max.apply(null, values) * 1.15;

  function getX(index) {
    return (
      padding.left +
      (index * (width - padding.left - padding.right)) / (data.length - 1)
    );
  }

  function getY(value) {
    return (
      padding.top +
      (height - padding.top - padding.bottom) * (1 - value / maxValue)
    );
  }

  let linePath = "M" + getX(0) + "," + getY(values[0]);
  let areaPath = linePath;

  for (let index = 1; index < values.length; index += 1) {
    const controlX = (getX(index - 1) + getX(index)) / 2;
    const segment =
      " C" +
      controlX +
      "," +
      getY(values[index - 1]) +
      " " +
      controlX +
      "," +
      getY(values[index]) +
      " " +
      getX(index) +
      "," +
      getY(values[index]);

    linePath += segment;
    areaPath += segment;
  }

  areaPath +=
    " L" +
    getX(values.length - 1) +
    "," +
    (height - padding.bottom) +
    " L" +
    getX(0) +
    "," +
    (height - padding.bottom) +
    " Z";

  return (
    <svg className="profit-chart" viewBox={"0 0 " + width + " " + height} preserveAspectRatio="none">
      <defs>
        <linearGradient id="profitChartGradient" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor="rgba(30,58,138,0.15)" />
          <stop offset="100%" stopColor="rgba(30,58,138,0)" />
        </linearGradient>
      </defs>
      {[0, maxValue / 2, maxValue].map(function renderTick(tick, index) {
        return (
          <g key={index}>
            <text x={padding.left - 8} y={getY(tick) + 4} textAnchor="end" fontSize="10" fill="var(--profit-text-3)" fontFamily="DM Mono, monospace">
              {"$" + Math.round(tick)}
            </text>
            <line x1={padding.left} y1={getY(tick)} x2={width - padding.right} y2={getY(tick)} stroke="var(--profit-border)" strokeWidth="1" strokeDasharray="4 3" />
          </g>
        );
      })}
      {data.map(function renderLabel(point, index) {
        return (
          <text key={point.month} x={getX(index)} y={height - padding.bottom + 16} textAnchor="middle" fontSize="10" fill="var(--profit-text-3)">
            {point.month.split(" ")[0]}
          </text>
        );
      })}
      <path d={areaPath} fill="url(#profitChartGradient)" />
      <path d={linePath} fill="none" stroke="#1e3a8a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
